import { Component, Input, SimpleChanges, OnDestroy } from '@angular/core';
import * as _ from 'lodash';
import * as Highcharts from 'highcharts';
import { HttpClient } from '@angular/common/http';
import { LineOrTrendedService } from '../../line-or-trended.service';
import { Observable, Subscription } from 'rxjs';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import {
  COMMON_CONSTANTS,
  COMMON_CONSTANTS_Percentage,
  COMMON_CONSTANTS_SNAPSHOT,
} from 'src/app/common/constants/common-constants';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { debug } from 'console';
import { formatMmaLabelForDisplay } from 'src/app/common/utils/time-period-display.util';
import { normalizePercentage } from 'src/app/modules/snapshot/custom-snapshot-chart-modules/chart-value.util';

@Component({
  selector: 'app-line-or-trend-chart1-custom',
  template: `<div [id]="chartContainerId" [style]="'height:' + height"></div>`,
})
export class Lineortrendchart1ComponentCustom implements OnDestroy {
  @Input() brandSelected: any = '';
  @Input() metricSelected: any = '';
  data: any;
  LineChartData: any[] = [];
  ChartProperties: any;
  categoriesList: any;
  updateCategoryName: any = [];
  colorCodeList: any[] = [];
  seriesData: any[] = [];
  chart: any;
  /** Unique DOM id — shared 'chart-container' caused popup Trend View to paint into the wrong node. */
  chartContainerId = `chart-container-${Math.random().toString(36).slice(2, 9)}`;
  custom: any[] = [];
  event: any;
  changeValue: any[] = [];
  significanceValue: any;
  sampleSizeValues: any[] = [];
  actualDataValue: any[] = [];
  chartCategories: any;
  samplesizeConstantValue = 1000;
  chartMinAxis: any;
  chartMaxAxis: any;
  hasNumericTrendData = false;
  showLowSample: any;
  tickInterval = 10;
  tickIntervalForStacking = 50;
  @Input() trendData: any;
  @Input() id: any;
  @Input() Top10Toggle: any = false;
  @Input() DataLabelOn: any;
  @Input() isOutput: any;
  // store global color map from SnapshotService
  globalColorMap: { [key: string]: string } = {};

  constructor(
    public http: HttpClient,
    public LineTrendService: LineOrTrendedService,
    private _customSnapshotService: CustomsnapshotService,
    private _configService: SnapshotService,
  ) {}
  @Input() height: any = '24em';
  ngOnInit(): void {
    // Try to get the current global color map synchronously first
    const currentGlobalColorMap = this._configService.getGlobalColorMap();
    if (
      currentGlobalColorMap &&
      Object.keys(currentGlobalColorMap).length > 0
    ) {
      this.globalColorMap = currentGlobalColorMap;
    }

    // subscribe to global color map from service so we pick up colors even if set after init
    this.serviceSubscriptions.add(
      this._configService.globalColorMap$.subscribe((map) => {
        if (map && Object.keys(map).length > 0) {
          this.globalColorMap = map;
          // re-prepare series and redraw to apply new colors
          try {
            this.prepareSeriesDataForChart();
            if (this.chart) this.plotLineChart(this.chartContainerId);
          } catch (e) {}
        }
      }),
    );
    if (this.isOutput && !this.shouldUseMetricTrendSeries()) {
      const initialMetric = this._customSnapshotService.getSelectedMetricSync(
        String(this.id ?? ''),
      );
      if (initialMetric) {
        this.metricSelected = initialMetric;
      }
      if (this.id != null && this.id !== '') {
        this.serviceSubscriptions.add(
          this._customSnapshotService
            .getSelectedMetric(String(this.id))
            .subscribe((selectedMetric) => {
              if (selectedMetric) {
                this.metricSelected = selectedMetric;
                this.updatesig();
              }
            }),
        );
      }
      this.updatesig();
    } else if (this.isOutput) {
      this.metricSelected = '';
      this.brandSelected = '';
      this.updatesig();
    } else {
      //this.categoriesList = ["Oct'2023", "Nov'2023", "Dec'2023", "Jan'2024", "Feb'2024"]
      this.http.get<any>('assets/Data/lineChartData.json').subscribe(
        (jsonData) => {
          this.data = jsonData[0];
          this.LineChartData = jsonData[0].data;
          this.ChartProperties = jsonData[0].properties[0];
          this.ChartProperties.decimalRoundOff = 2;
          this.ChartProperties.legendPosition = 'bottom';
          this.colorCodeList = jsonData[0].ColorCodes;
          this.plotLineChart(this.chartContainerId);
        },
        (error) => {
          console.error('Error fetching data:', error);
        },
      );
    }
  }

  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  DefaultConfidenceLevel: any = '';
  private subscriptions: Subscription = new Subscription();
  private serviceSubscriptions: Subscription = new Subscription();

  ngOnDestroy(): void {
    try {
      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }
      this.subscriptions.unsubscribe();
    } catch (e) {}
    try {
      this.serviceSubscriptions.unsubscribe();
    } catch (e) {}
  }
  updatesig() {
    this.Sig_LowerLimt =
      this.DefaultConfidenceLevel ==
      COMMON_CONSTANTS_Percentage.ConfidencePercent_95
        ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
        : this.DefaultConfidenceLevel ==
            COMMON_CONSTANTS_Percentage.ConfidencePercent_90
          ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
          : this.DefaultConfidenceLevel ==
              COMMON_CONSTANTS_Percentage.ConfidencePercent_98
            ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_98
            : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
    this.Sig_UpperLimt =
      this.DefaultConfidenceLevel ==
      COMMON_CONSTANTS_Percentage.ConfidencePercent_95
        ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
        : this.DefaultConfidenceLevel ==
            COMMON_CONSTANTS_Percentage.ConfidencePercent_90
          ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
          : this.DefaultConfidenceLevel ==
              COMMON_CONSTANTS_Percentage.ConfidencePercent_98
            ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_98
            : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;

    this.preparemainChartData(this.trendData);
    this.subscriptions.add(
      this._configService.confedenceValue.subscribe((value) => {
        this.DefaultConfidenceLevel = value;
      }),
    );
    this.subscriptions.add(
      this._configService.significanceValue.subscribe((value) => {
        this.significanceValue = value;
      }),
    );
    this.subscriptions.add(
      this.http.get<any>('assets/Data/lineChartData.json').subscribe(
        (jsonData) => {
          this.ChartProperties = jsonData[0].properties[0];

          this.colorCodeList = this.LineTrendService.color1;
          // this.colorCodeList = jsonData[0].ColorCodes;
          const hasNullColChild = JSON.stringify(this.trendData ?? '').includes(
            '"colChild":null',
          );
          if (!hasNullColChild) {
            this.ChartProperties.datalabelStyle =
              this.significanceValue == 'None' ? 'datalabel' : 'sigChange';
            this.ChartProperties.datalabelStyle = this._configService
              .isIndexSelected
              ? 'index'
              : this.ChartProperties.datalabelStyle;
          }

          this.plotLineChart(this.chartContainerId);
        },
        (error) => {
          console.error('Error fetching data:', error);
        },
      ),
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    const relevantKeys = [
      'trendData',
      'brandSelected',
      'metricSelected',
      'isOutput',
      'DataLabelOn',
      'Top10Toggle',
    ];
    if (!relevantKeys.some((key) => key in changes)) {
      return;
    }
    this.updatesig();
    // Do NOT call ngOnInit() here — updatesig() already handles redraw,
    // and calling ngOnInit() would create duplicate subscriptions.
  }
  chartMainData: any = [];

  private normalizeMetricKey(name: string): string {
    return (name || '')
      .split('|')
      .map((part) => part.trim())
      .filter(Boolean)
      .join('|')
      .toLowerCase();
  }

  private metricsMatch(filter: string, candidate: string): boolean {
    if (!filter) {
      return true;
    }
    if (!candidate) {
      return false;
    }

    const normalizedFilter = this.normalizeMetricKey(filter);
    const normalizedCandidate = this.normalizeMetricKey(candidate);

    if (normalizedFilter === normalizedCandidate) {
      return true;
    }

    const lastTwoSegments = (name: string): string => {
      const parts = name
        .split('|')
        .map((part) => part.trim())
        .filter(Boolean);
      if (parts.length <= 2) {
        return this.normalizeMetricKey(name);
      }
      return this.normalizeMetricKey(parts.slice(-2).join('|'));
    };

    if (lastTwoSegments(filter) === lastTwoSegments(candidate)) {
      return true;
    }

    const secondSegment = (name: string): string => {
      const parts = name
        .split('|')
        .map((part) => part.trim())
        .filter(Boolean);
      if (parts.length >= 2 && parts[1].toLowerCase().includes('t2b')) {
        return this.normalizeMetricKey(`${parts[0]}|${parts[1]}`);
      }
      return parts.length >= 2 ? this.normalizeMetricKey(parts[1]) : '';
    };
    const filterSecond = secondSegment(filter);
    const candidateSecond = secondSegment(candidate);
    if (
      filterSecond &&
      (normalizedCandidate === filterSecond ||
        normalizedFilter === candidateSecond ||
        normalizedCandidate.includes(filterSecond) ||
        normalizedFilter.includes(candidateSecond))
    ) {
      return true;
    }

    return (
      normalizedFilter.includes(normalizedCandidate) ||
      normalizedCandidate.includes(normalizedFilter)
    );
  }

  private resolveSourceChartType(widget: any): string {
    return (
      widget?.sourceWidgetChartName ??
      widget?.widgetchart_name ??
      ''
    )
      .toString()
      .trim()
      .toLowerCase();
  }

  /** Brand-independent (false) and gauge widgets plot metrics as series. */
  private isGaugeTrendWidget(): boolean {
    return this.resolveSourceChartType(this.trendData) === 'gauge';
  }

  private shouldUseMetricTrendSeries(): boolean {
    // Gauge trend popups must plot metrics over time — check chart type before
    // isBrandDependent / JSON parse so a rename to "Line Chart" can't blank the series.
    if (this.trendData?.useMetricTrendSeries === true) {
      return true;
    }
    if (this.isGaugeTrendWidget()) {
      return true;
    }

    if (this.trendData?.isBrandDependent === true) {
      return false;
    }

    if (this.trendData?.isBrandDependent === false) {
      return true;
    }

    try {
      const rawProps = this.trendData?.customizationProperties;
      const props =
        typeof rawProps === 'string'
          ? JSON.parse(rawProps || '{}')
          : rawProps || {};
      if (props?.bdBiToggle === false || props?.bdBiToggle === 'false') {
        return true;
      }
    } catch {
      // fall through — do not block gauge/BI detection on bad JSON
    }

    return false;
  }

  private normalizeTrendPeriodLabel(value: any): string {
    return (value ?? '')
      .toString()
      .replace(/^(Month|Year|Quarter|Week|Time Period)\|/i, '')
      .replace(/\s+/g, '');
  }

  private isTimePeriodColChild(colChild: any): boolean {
    const raw = (colChild ?? '').toString();
    return /^(Quarter|Month|Week|Year|Time Period)\|/i.test(raw);
  }

  private isTimePeriodLabel(value: any): boolean {
    const normalized = this.normalizeTrendPeriodLabel(value);
    return /^Q\d+_\d{4}$/i.test(normalized) || /^\w+_\d{4}$/.test(normalized);
  }

  private compareTrendPeriodLabels(a: string, b: string): number {
    const parse = (label: string) => {
      const normalized = this.normalizeTrendPeriodLabel(label);
      const quarterMatch = normalized.match(/^Q(\d+)_(\d{4})$/i);
      if (quarterMatch) {
        return {
          year: parseInt(quarterMatch[2], 10),
          period: parseInt(quarterMatch[1], 10),
        };
      }

      const genericMatch = normalized.match(/^(\w+)_(\d{4})$/);
      if (genericMatch) {
        return {
          year: parseInt(genericMatch[2], 10),
          period: this.getMonthNumber(genericMatch[1]),
        };
      }

      return { year: 0, period: 0 };
    };

    const left = parse(a);
    const right = parse(b);
    if (left.year !== right.year) {
      return left.year - right.year;
    }
    return left.period - right.period;
  }

  private hasTrendRowData(row: any): boolean {
    return row?.data != null && row?.data !== 'NA';
  }

  private preferTrendRow(candidate: any, current: any): boolean {
    const candidateHasData = this.hasTrendRowData(candidate);
    const currentHasData = this.hasTrendRowData(current);
    if (candidateHasData && !currentHasData) {
      return true;
    }
    if (!candidateHasData && currentHasData) {
      return false;
    }

    if (!this.shouldUseMetricTrendSeries()) {
      return false;
    }

    const category = this.resolveTrendCategoryName(candidate);
    const candidateCol = this.normalizeTrendPeriodLabel(candidate?.colChild);
    const currentCol = this.normalizeTrendPeriodLabel(current?.colChild);
    if (candidateCol === category && currentCol !== category) {
      return true;
    }
    if (candidateCol !== category && currentCol === category) {
      return false;
    }

    return false;
  }

  private resolveTrendCategoryName(dataArr: any): string {
    if (this.shouldUseMetricTrendSeries()) {
      if (this.isTimePeriodColChild(dataArr.colChild)) {
        return this.normalizeTrendPeriodLabel(dataArr.colChild);
      }

      const levelPeriod = dataArr.lvl1Child ?? dataArr.Level1ColChild;
      if (this.isTimePeriodLabel(levelPeriod)) {
        return this.normalizeTrendPeriodLabel(levelPeriod);
      }
    }

    let raw = (
      dataArr.lvl1Child ??
      dataArr.Level1ColChild ??
      ''
    ).toString();

    if (!raw && this.isTimePeriodColChild(dataArr.colChild)) {
      raw = (dataArr.colChild ?? '').toString();
    }

    return this.normalizeTrendPeriodLabel(raw);
  }

  private resolveTrendSeriesName(
    lev2: any,
    dataArr: any,
    branch: 'metric' | 'brand' | 'all',
  ): string {
    if (this.shouldUseMetricTrendSeries()) {
      return (
        lev2.option ??
        lev2.metricName ??
        dataArr.rowChild ??
        ''
      ).toString();
    }

    if (branch === 'metric') {
      if (dataArr.colChild != null && dataArr.colChild !== '') {
        return dataArr.colChild.split('|').length > 1
          ? dataArr.colChild.split('|')[1]
          : dataArr.colChild;
      }
      return dataArr.rowChild;
    }

    if (branch === 'brand') {
      return dataArr.rowChild;
    }

    return this._configService.selectedSnapshotType.toLowerCase().includes('multi')
      ? dataArr.colChild ?? dataArr.rowChild
      : dataArr.rowChild;
  }

  private dedupeTrendRowsByTimePeriod(rows: any[] = []): any[] {
    const bestByPeriod = new Map<string, any>();
    const passthroughRows: any[] = [];

    rows.forEach((row: any) => {
      const timePeriod = this.resolveTrendCategoryName(row);
      if (!timePeriod) {
        passthroughRows.push(row);
        return;
      }

      const existing = bestByPeriod.get(timePeriod);
      if (!existing || this.preferTrendRow(row, existing)) {
        bestByPeriod.set(timePeriod, row);
      }
    });

    const keptRows = new Set(bestByPeriod.values());
    const dedupedRows = rows.filter((row: any) => {
      const timePeriod = this.resolveTrendCategoryName(row);
      if (!timePeriod) {
        return true;
      }
      return keptRows.has(row);
    });

    if (this.shouldUseMetricTrendSeries()) {
      dedupedRows.sort((a: any, b: any) =>
        this.compareTrendPeriodLabels(
          this.resolveTrendCategoryName(a),
          this.resolveTrendCategoryName(b),
        ),
      );
    }

    return dedupedRows.length > 0 ? dedupedRows : passthroughRows;
  }

  private getTrendRowsForMetric(lev2: any): any[] {
    const rows = lev2.data || [];
    if (!this.shouldUseMetricTrendSeries()) {
      return rows;
    }

    const nonBrandRows = rows.filter(
      (row: any) => !(row.colChild ?? '').toString().startsWith('Brands|'),
    );
    const filteredRows = nonBrandRows.length > 0 ? nonBrandRows : rows;

    return this.dedupeTrendRowsByTimePeriod(filteredRows);
  }

  private buildTrendChartPoint(
    lev2: any,
    dataArr: any,
    isTotalBase: boolean,
    branch: 'metric' | 'brand' | 'all',
  ): any {
    return {
      'Series Name': this.resolveTrendSeriesName(lev2, dataArr, branch),
      'Category Name': formatMmaLabelForDisplay(
        (
          this.shouldUseMetricTrendSeries()
            ? this.resolveTrendCategoryName(dataArr)
            : (dataArr.lvl1Child ?? '').replace(/^(Month|Year|Quarter)\|/, '')
        )
          .toString()
          .replace(/\|/g, ' : '),
      ),
      'Rounded Value':
        dataArr.data == null
          ? null
          : dataArr.CalculationType?.toLowerCase() == 'share' ||
              dataArr.CalculationType?.toLowerCase() == 'respgrp'
            ? normalizePercentage(dataArr.data)
            : dataArr.data,
      Value:
        dataArr.CalculationType?.toLowerCase() == 'share' ||
        dataArr.CalculationType?.toLowerCase() == 'respgrp'
          ? normalizePercentage(dataArr.data)
          : dataArr.data,
      ValueForIndex:
        dataArr.CalculationTypeIndex?.toLowerCase() == 'index' &&
        dataArr.data2 == 'NA'
          ? 'NA'
          : dataArr.data2,
      ActualIndexValue:
        dataArr.CalculationTypeIndex?.toLowerCase() == 'index' &&
        dataArr.data2 == null
          ? null
          : dataArr.CalculationTypeIndex?.toLowerCase() == 'index' &&
              dataArr.data2 == 'NA'
            ? 'NA'
            : dataArr.data2,
      Label:
        dataArr.data == null
          ? 'NA'
          : dataArr.CalculationType?.toLowerCase() == 'share' ||
              dataArr.CalculationType?.toLowerCase() == 'respgrp'
            ? normalizePercentage(dataArr.data)
            : dataArr.data,
      ChangeVs: isTotalBase
        ? dataArr.changeVsPY_Total
        : dataArr.changeVsPY_Answer,
      Significance: '-1',
      'Sample size':
        this._configService.baseSelected.toLowerCase() == 'total base'
          ? dataArr.totalUnweightedBase
          : dataArr.answerUnweightedBase,
      Significance2: '1',
      'Category Image': 'Category_Image_1',
      isPercentage:
        dataArr.CalculationType?.toLowerCase() == 'share' ||
        dataArr.CalculationType?.toLowerCase() == 'respgrp'
          ? true
          : false,
      Sig_LowerLimt: this.Sig_LowerLimt,
      Sig_UpperLimt: this.Sig_UpperLimt,
      Significance_Value: dataArr.Significance_Value,
      isAdditionalKPI: lev2.isAdditionalKPI ?? false,
    };
  }

  preparemainChartData(data: any) {
    this.Top10Toggle = false;
    let isTotalBase =
      this._configService.finalLeftPanelSubmitObject.isTotalBase;
    this.chartMainData = [];
    if (this.shouldUseMetricTrendSeries()) {
      this.metricSelected = '';
      this.brandSelected = '';
    } else if (
      !this._configService.selectedSnapshotType.toLowerCase().includes('multi')
    ) {
      this.metricSelected = '';
      this.brandSelected = '';
    }
    if (!data?.metric?.length) {
      return;
    }
    const isMultipleBrands =
      this._configService.selectedcompareacrossOption?.includes(
        'Multiple Brands',
      );
    const selectedMetricFilter = (this.metricSelected ?? '').toString().trim();

    data.metric.forEach((lev1: any) => {
      const filteredMetricValue =
        isMultipleBrands && selectedMetricFilter
          ? lev1.metric_value.filter((lev2: any) => {
              const optionName = (lev2.option ?? lev2.metricName ?? '')
                .toString()
                .trim();
              if (this.metricsMatch(selectedMetricFilter, optionName)) {
                return true;
              }
              // Same as Sample Size: selected metric often lives on rowChild
              return (lev2.data || []).some((d: any) =>
                this.metricsMatch(selectedMetricFilter, d.rowChild ?? ''),
              );
            })
          : lev1.metric_value;

      filteredMetricValue.forEach((lev2: any, index: number) => {
        const trendRows = this.getTrendRowsForMetric(lev2);
        if (
          trendRows.length > 0 &&
          trendRows[0]?.lvl1Child?.split('|')[0] === 'Year'
        ) {
          trendRows.sort((a: any, b: any) => {
            const valueA = parseInt(a.lvl1Child?.split('|').pop() ?? '0', 10);
            const valueB = parseInt(b.lvl1Child?.split('|').pop() ?? '0', 10);
            return valueA - valueB;
          });
        }
        if (
          this.Top10Toggle == false ||
          (this.Top10Toggle == true && index < 10)
        ) {
          if (this.metricSelected != '') {
            const conditionCheck =
              lev2.option == null ? lev2.metricName : lev2.option;
            const rowsHaveRowChild = trendRows.some(
              (r: any) => !!(r?.rowChild ?? '').toString().trim(),
            );
            trendRows.forEach((dataArr: any) => {
              const matchesRow = this.metricsMatch(
                this.metricSelected,
                dataArr.rowChild ?? '',
              );
              const matchesOption = this.metricsMatch(
                this.metricSelected,
                conditionCheck ?? '',
              );
              // Prefer rowChild (Sample Size style); fall back to option when no rowChild
              if (rowsHaveRowChild ? matchesRow : matchesOption) {
                this.chartMainData.push(
                  this.buildTrendChartPoint(
                    lev2,
                    dataArr,
                    isTotalBase,
                    'metric',
                  ),
                );
              }
            });
          }
          if (this.brandSelected != '') {
            trendRows.forEach((dataArr: any) => {
              if (dataArr.colChild == this.brandSelected) {
                this.chartMainData.push(
                  this.buildTrendChartPoint(
                    lev2,
                    dataArr,
                    isTotalBase,
                    'brand',
                  ),
                );
              }
            });
          }
          if (this.brandSelected == '' && this.metricSelected == '') {
            trendRows.forEach((dataArr: any) => {
              this.chartMainData.push(
                this.buildTrendChartPoint(lev2, dataArr, isTotalBase, 'all'),
              );
            });
          }
        }
      });
    });
  }

  commonfunc(event: any, customization: string, options: any) {
    this.event = event;
    this.ChartProperties = this.LineTrendService.commonFunc(
      customization,
      event,
      this.ChartProperties,
    );
    this.plotLineChart(this.chartContainerId);
  }

  plotyaxis() {
    if (
      this.ChartProperties.stacking == 1 ||
      this.ChartProperties.stacking == 2
    ) {
      return {
        title: {
          text: '',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
        },

        gridLineWidth: this.ChartProperties.gridlines,
        labels: {
          rotation: this.LineTrendService.axisLabelOrientation(
            this.ChartProperties.yaxisLabelOrientation,
          ),
          format:
            this.ChartProperties.datalabelFormat == 'number'
              ? '{value}'
              : '{value}%',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
        },
      };
    } else {
      // return {
      //   title: {
      //     text: '',
      //     style: {
      //       color: this.ChartProperties.darkTheme ? 'white' : 'Black',
      //     },
      //   },
      //   min: this.showLowSample ? 0 : this.chartMinAxis,
      //   // max: this.chartMaxAxis > 100 ? 100 : this.chartMaxAxis,
      //   max: this.chartMaxAxis,
      //   gridLineWidth: this.ChartProperties.gridlines,
      //   labels: {
      //     rotation: this.LineTrendService.axisLabelOrientation(
      //       this.ChartProperties.yaxisLabelOrientation
      //     ),
      //     format:
      //       this.ChartProperties.datalabelFormat == 'number'
      //         ? '{value}'
      //         : '{value}%',
      //     style: {
      //       color: this.ChartProperties.darkTheme ? 'white' : 'Black',
      //     },
      //   },
      // };
      return {
        title: {
          text: '',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
        },
        min: this.hasNumericTrendData && this.chartMinAxis >= 0
          ? 0
          : this.chartMinAxis,
        max: this.chartMaxAxis,
        tickInterval: 10, // Set the tick interval to always be 10
        gridLineWidth: this.ChartProperties.gridlines,
        labels: {
          rotation: this.LineTrendService.axisLabelOrientation(
            this.ChartProperties.yaxisLabelOrientation,
          ),
          format:
            this.ChartProperties.datalabelFormat == 'number'
              ? '{value}'
              : '{value}%',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
        },
      };
    }
  }

  plotLineChart(containerId: any) {
    if (this.isOutput) {
      localStorage.setItem('properties', JSON.stringify(this.ChartProperties));
      this.prepareSeriesDataForChart();
      const containerEl = document.getElementById(containerId);
      if (!this.hasNumericTrendData) {
        if (containerEl) {
          containerEl.innerHTML =
            '<div style="display:flex;align-items:center;justify-content:center;height:100%;font-family:KantarBrown-Regular;color:#333;">No chart configured</div>';
        }
        this.chart = null;
        return;
      }
      let properties = this.ChartProperties;
      let samplesizeConstantValue = this._configService.ISthreshold;
      //const updatedCategoryNames = this.LineTrendService.updatedCategories.map(category => category.image);
      //let updatedCategories = this.LineTrendService.updatedCategories;
      let ispercentage = false;
      let that = this;
      let colors = this.colorCodeList;
      if (this.ChartProperties.datalabelFormat === 'percentage') {
        ispercentage = true;
      }

      if (
        this.ChartProperties.stacking == 1 ||
        this.ChartProperties.stacking == 2
      ) {
        this.seriesData.reverse();
      }

      let configService = this._configService;

      if (!containerEl) {
        return;
      }
      this.chart = new Highcharts.Chart(containerEl, {
        chart: {
          type: 'line',
          marginLeft: 50, // Increase left margin
          marginRight: 20,
          animation: false,
          height: '38%',
          width: null,
          backgroundColor: this.ChartProperties.darkTheme ? 'Black' : 'white',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
            fontFamily: 'KantarBrown-Regular',
            fontSize: '0.7rem',
          },
          zoomType: 'xy',
        },
        title: {
          text: '',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
          align: this.ChartProperties.chartTitlePosition,
        },
        credits: {
          enabled: false,
        },
        yAxis: this.plotyaxis(),
        xAxis: {
          title: {
            text: '',
            style: {
              fontSize: '12px',
              color: '#E8E8E8',
            },
          },
          // min: 0,
          gridLineWidth: this.ChartProperties.gridlines,
          categories: properties.axisImage
            ? this.updateCategoryName
            : this.categoriesList,
          labels: {
            rotation: this.LineTrendService.axisLabelOrientation(
              this.ChartProperties.axisLabelOrientation,
            ),
            style: {
              color: this.ChartProperties.darkTheme ? 'white' : 'Black',
            },
            useHTML: true,
            formatter: function (
              this: Highcharts.AxisLabelsFormatterContextObject,
            ) {
              if (properties.axisImage) {
                var index = this.axis.categories.indexOf(String(this.value));
                var category = that.updateCategoryName[index];

                if (category) {
                  return (
                    '<span style="display: inline-block; width: 2em; height: 2em; background: url(../../../../../../assets/Images/LineOrTrendChart/' +
                    category +
                    '.png) no-repeat center center; background-size: cover;"></span>'
                  );
                } else {
                  return '<span>No Image</span>';
                }
              } else {
                return String(this.value);
              }
            },
          },
        },

        tooltip: {
          enabled: true,
          borderWidth: 0,
          useHTML: true,
          shape: properties.toolTipStyle == 'style1' ? 'square' : 'callout',
          shadow: false,
          backgroundColor: 'rgba(0,0,0,0)',

          formatter: function (this: any) {
            const pointWithMetric = (
              this as Highcharts.TooltipFormatterContextObject
            ).point as {
              name?: any;
              parent?: any;
              color?: any;
              y?: number;
              y1?: number;
              cov?: string;
              significance?: string;
              samplesize?: number;
              significance2?: any;
              tooltip?: any;
              isPercentage?: any;
              Sig_LowerLimt?: any;
              Sig_UpperLimt?: any;
              Significance_Value?: any;
              indexValue?: any;
            };

            let roundedValue =
              this.series.userOptions.data1[this.point.x]['Rounded Value'];
            properties.dataLabelFormat = pointWithMetric.isPercentage;
            if (
              roundedValue == null &&
              properties.datalabelStyle == 'datalabel'
            )
              return 'NA';
            if (properties.datalabelStyle === 'index') {
              let finalText: any =
                roundedValue == null
                  ? 'NA'
                  : configService.CheckLSorIScondition(
                      configService.userRole,
                      this.y +
                        (this.series.userOptions.data1[this.point.x][
                          'isPercentage'
                        ] && '%'),
                      this.series.userOptions.data1[this.point.x][
                        'Sample size'
                      ],
                    );
              // pointWithMetric.tooltip = finalText;

              let text2 =
                pointWithMetric.y1 != null ? pointWithMetric.indexValue : 'NA';
              //text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
              let color = configService.CheckIndexColoring(String(text2));
              text2 = `<span style="color: ${color} ;">${text2}</span>`;
              pointWithMetric.tooltip = finalText + '(' + text2 + ')';
              // return (
              //   '<span style="color:' + 'black' + ';">' + text + '</span>'
              // );
            } else if (properties.datalabelStyle === 'sigChange') {
              let changeVal = pointWithMetric.isPercentage
                ? Number(pointWithMetric.cov) * 100
                : Number(pointWithMetric.cov);
              if (pointWithMetric.cov == null || pointWithMetric.cov == 'NA') {
                let text =
                  pointWithMetric.y1 != null
                    ? pointWithMetric.y +
                      (properties.dataLabelFormat ? '%' : '') +
                      ' ' +
                      `<span span style="font-size: 80%;color:black;">(${'NA'})</span>`
                    : 'NA';
                pointWithMetric.tooltip = text;
                // return (
                //   '<span style:"color:' + 'black' + ';">' + text + '</span>'
                // );
              } else {
                let val =
                  pointWithMetric.y != null
                    ? pointWithMetric.y +
                      (properties.dataLabelFormat ? '%' : '')
                    : 'NA';
                // val = configService.CheckLSorIScondition(
                //   configService.userRole,
                //   val,
                //   pointWithMetric.samplesize ? pointWithMetric.samplesize : 0
                // );

                if (val == 'I/S') {
                  pointWithMetric.tooltip = val;
                } else {
                  let sigValvalidate =
                    pointWithMetric.Significance_Value;
                  let sigClass =
                    sigValvalidate < pointWithMetric.Sig_LowerLimt
                      ? 'red'
                      : sigValvalidate > pointWithMetric.Sig_UpperLimt
                        ? 'green'
                        : 'black';
                  let text =
                    pointWithMetric.y1 != null
                      ? pointWithMetric.y +
                        (properties.dataLabelFormat ? '%' : '') +
                        ' ' +
                        `<span style="font-size: 80%;  color: ${sigClass};">(` +
                        `${
                          pointWithMetric.cov != null
                            ? Math.round(Number(changeVal)) +
                              (pointWithMetric.isPercentage ? '%' : '')
                            : 'NA'
                        })</span>`
                      : 'NA';
                  pointWithMetric.tooltip = text;
                }
                // return (
                //   '<span style:"color:' + 'black' + ';">' + text + '</span>'
                // );
              }
            } else {
              let finalText =
                this.y +
                (this.series.userOptions.data1[this.point.x]['isPercentage'] &&
                  '%');
              finalText = configService.CheckLSorIScondition(
                configService.userRole,
                finalText,
                this.series.userOptions.data1[this.point.x]['Sample size'],
              );
              pointWithMetric.tooltip = finalText;
            }

            if (this.series.name === 'Marker1') return false;
            let isDefaultTooltip = properties.toolTipStyle;
            const text = properties.showDataLabel
              ? this.series.userOptions.tooltip[this.point.x]
              : this.y;
            const dotColor = this.series.color;
            const backgroundcolor = properties.darkTheme
              ? '#b3b3b3'
              : '#f5f5f5';
            const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';
            if (isDefaultTooltip == 'style1') {
              const commonContent =
                `<div style="width:120%;border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 3%; border-radius: 5px; margin: 0; background-color: ${backgroundcolor2};">` +
                //`<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 1rem;">Tooltip Title</span>` +
                `<span><strong>Series Name:</strong></span> ${this.series.userOptions.name}<br>` +
                `<span><strong>Category Name:</strong></span> ${
                  this.series.userOptions.data1[this.point.x]['Category Name']
                }<br>` +
                `<span><strong>Value:</strong></span> ${pointWithMetric.tooltip}`;
              return commonContent + '</div>';
            } else {
              // Get the series color
              const content =
                `<div style="background-color: white; padding: 3%; align-items: center; border: 1px solid ${dotColor};min-width:120%;">` +
                `<div style="display:flex"><div style="width: 1em; height: 1em; background-color: ${dotColor}; border-radius: 50%;"> </div>` +
                `<div style="width:90%; padding-left:5%;"> ${this.series.name} </div></div>` +
                `<div style="display: block; margin-top: 1%; margin-left:12%;"><strong>Value:</strong> ${pointWithMetric.tooltip}</div>`;
              return content + '</div>';
            }
          },
        } as any,
        // legend: this.LineTrendService.customizeLegend(properties.showLegend, properties.legendPosition, this.ChartProperties.darkTheme, this.ChartProperties.stacking),
        legend: {
          enabled: true,
          events: {
            itemHover: function (event: any) {
              // Display tooltip when hovering over legend item
              const point = event.target;
              const tooltip = document.createElement('div');
              tooltip.className = 'custom-tooltip';
              tooltip.style.position = 'absolute';
              tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
              tooltip.style.color = 'white';
              tooltip.style.padding = '5px';
              tooltip.style.borderRadius = '3px';
              tooltip.style.pointerEvents = 'none';
              tooltip.innerText = point.name;
              document.body.appendChild(tooltip);

              // Position tooltip
              document.addEventListener('mousemove', function (e) {
                tooltip.style.left = e.pageX + 10 + 'px';
                tooltip.style.top = e.pageY + 10 + 'px';
              });
            },
            itemMouseOut: function (event: any) {
              // Remove tooltip when mouse leaves legend item
              const tooltip = document.querySelector('.custom-tooltip');
              if (tooltip) {
                tooltip.remove();
              }
            },
          },
          // reversed: (this.ChartProperties.stacking == 1 || this.ChartProperties.stacking == 2) ? true : false,
          align: 'center',
          verticalAlign: 'bottom',
          layout: 'horizontal',
          maxHeight: 120, // Limit legend height, enables Highcharts pagination
          // itemStyle: {
          //   color: "Black",
          //   fontWeight: "normal",
          //   fontSize: "0.8em",
          //   fontFamily: "Kantar Regular"
          // },
          itemStyle: {
            fontWeight: 'normal',
            fontSize: this.height != '100%' ? '0.8em' : '1em',
            cursor: 'pointer',
          },
          useHTML: true,
          // symbolWidth: -1,
          // symbolHeight: -1,
          labelFormatter: function (): any {
            let point = this as any;
            // let textcolor = chartproperties.darkTheme ? 'white' : 'black';
            if (point.color != '#eeebed' && point.color != '#7f7f7f') {
              return (
                '<div style="display:flex;align-items:center;font-size:0.8em;" title="' +
                point.name +
                '">' +
                '<div style="display:flex;width:10px;height:10px;background-color:' +
                point.legendkeycolor +
                ';border-radius:50%"></div>' +
                '<div style="z-index: 10000; height: 20px; padding-left: 10px; padding-top: 1%; color: black; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; flex: 1; font: KantarBrown-Regular; cursor: pointer;" title="' +
                point.name +
                '">' +
                '   ' +
                point.name +
                '   ' +
                '</div>' +
                '</div>'
              );
            }
          },
        },
        plotOptions: {
          series: {
            animation: false,
          },
          line: {
            stacking:
              this.ChartProperties.stacking == 0
                ? ''
                : this.ChartProperties.stacking == 1
                  ? 'normal'
                  : 'percent',
            lineWidth: properties.lineWidth,
            dashStyle: properties.gridLineDashStyle,
            fillOpacity: 0.4,
            marker: {
              enabled: true,
              symbol: properties.markerStyle,
              radius: 4,
              lineWidth: properties.markerLineWidth,
            },
            dataLabels: {
              enabled: this.DataLabelOn,
              allowOverlap: true,
              align:
                properties.dataLabelPosition == 'left'
                  ? 'right'
                  : properties.dataLabelPosition == 'right'
                    ? 'left'
                    : 'center',
              rotation: properties.datalabelOrientation,
              backgroundColor: 'transparent',
              color: properties.darkTheme
                ? properties.dataLabelColor === 'default'
                  ? 'white'
                  : properties.dataLabelColor
                : properties.dataLabelColor === 'default'
                  ? 'black'
                  : properties.dataLabelColor,
              style: {
                fontSize: properties.dataLabelSize,
                textOutline: 'none',
                fontWeight: 'normal',
              },
              formatter: function (this: any) {
                const pointWithMetric = (
                  this as Highcharts.TooltipFormatterContextObject
                ).point as {
                  name?: any;
                  parent?: any;
                  color?: any;
                  y?: number;
                  y1?: number;
                  cov?: string;
                  significance?: string;
                  samplesize?: number;
                  significance2?: any;
                  tooltip?: any;
                  isPercentage?: any;
                  Sig_LowerLimt?: any;
                  Sig_UpperLimt?: any;
                  Significance_Value?: any;
                  indexValue?: any;
                };
                const upwardTriangle = '&#9650';
                const downwardTriangle = '\u25BC';
                let roundedValue =
                  this.series.userOptions.data1[this.point.x]['Rounded Value'];
                properties.dataLabelFormat = pointWithMetric.isPercentage;
                if (
                  roundedValue == null &&
                  properties.datalabelStyle == 'datalabel'
                )
                  return 'NA';
                if (properties.datalabelStyle === 'index') {
                  let finalText: any =
                    roundedValue == null
                      ? 'NA'
                      : configService.CheckLSorIScondition(
                          configService.userRole,
                          this.y +
                            (this.series.userOptions.data1[this.point.x][
                              'isPercentage'
                            ] && '%'),
                          this.series.userOptions.data1[this.point.x][
                            'Sample size'
                          ],
                        );
                  pointWithMetric.tooltip = finalText;

                  let text2 =
                    pointWithMetric.y1 != null
                      ? pointWithMetric.indexValue
                      : 'NA';
                  //text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
                  let color = configService.CheckIndexColoring(String(text2));
                  text2 = `<span style="color: ${color} ;">${text2}</span>`;
                  pointWithMetric.tooltip = finalText + '(' + text2 + ')';
                  return (
                    '<span style="color:' +
                    'black' +
                    ';">' +
                    finalText +
                    '(' +
                    text2 +
                    ')' +
                    '</span>'
                  );
                }

                if (properties.datalabelStyle === 'sigChange') {
                  let changeVal = pointWithMetric.isPercentage
                    ? Number(pointWithMetric.cov) * 100
                    : Number(pointWithMetric.cov);
                  if (
                    pointWithMetric.cov == null ||
                    pointWithMetric.cov == 'NA'
                  ) {
                    let text =
                      pointWithMetric.y1 != null
                        ? pointWithMetric.y +
                          (properties.dataLabelFormat ? '%' : '') +
                          ' ' +
                          `<span span style="font-size: 80%;color:black;">(${'NA'})</span>`
                        : 'NA';
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style:"color:' + 'black' + ';">' + text + '</span>'
                    );
                  } else {
                    let val =
                      pointWithMetric.y != null
                        ? pointWithMetric.y +
                          (properties.dataLabelFormat ? '%' : '')
                        : 'NA';
                    // val = configService.CheckLSorIScondition(
                    //   configService.userRole,
                    //   val,
                    //   pointWithMetric.samplesize ? pointWithMetric.samplesize : 0
                    // );

                    if (val == 'I/S') {
                      return (
                        '<span style:"color:' +
                        'black' +
                        ';">' +
                        val +
                        '</span>'
                      );
                    }
                    let sigValvalidate = pointWithMetric.Significance_Value;
                    let sigClass =
                      sigValvalidate < pointWithMetric.Sig_LowerLimt
                        ? 'red'
                        : sigValvalidate > pointWithMetric.Sig_UpperLimt
                          ? 'green'
                          : 'black';

                    let text =
                      pointWithMetric.y1 != null
                        ? pointWithMetric.y +
                          (properties.dataLabelFormat ? '%' : '') +
                          ' ' +
                          `<span style="font-size: 80%;  color: ${sigClass};">(` +
                          `${
                            pointWithMetric.cov != null
                              ? Math.round(Number(changeVal)) +
                                (pointWithMetric.isPercentage ? '%' : '')
                              : 'NA'
                          })</span>`
                        : 'NA';
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style:"color:' + 'black' + ';">' + text + '</span>'
                    );
                  }
                }
                let finalText =
                  this.y +
                  (this.series.userOptions.data1[this.point.x][
                    'isPercentage'
                  ] && '%');
                finalText = configService.CheckLSorIScondition(
                  configService.userRole,
                  finalText,
                  this.series.userOptions.data1[this.point.x]['Sample size'],
                );
                pointWithMetric.tooltip = finalText;
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
                // if (properties.datalabelStyle == "significance + changeVs") {
                //   text = this.y + (this.series.userOptions.data1[this.point.x]["isPercentage"] && '%');
                //   changeText = this.series.userOptions.data1[this.point.x]["ChangeVs"];
                //   let sig = this.series.userOptions.data1[this.point.x]["Significance"];
                //   let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                //   let sigcolor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                //   let finalText = '<span>' + text +
                //     (changeText ? '&nbsp;<span>' +
                //       '' + `<span style="font-size: 80%; color:${properties.darkTheme ? "white" : "black"}">(` + changeText + ')</span>' + '&nbsp;' +
                //       '<span style="color:' + sigcolor + ';">' + s + '</span>' : '') +
                //     '</span>';
                //   this.series.userOptions.tooltip[this.point.x] = finalText;

                //   return (
                //     finalText
                //   );
                // }

                // if (properties.datalabelStyle == "change") {
                //   text = this.y + (this.series.userOptions.data1[this.point.x]["isPercentage"] && '%')
                //   //text = this.y != 0 ? this.y + ( ispercentage && '%' ) : 'NA';
                //   changeText = this.series.userOptions.data1[this.point.x]["ChangeVs"];
                //   let finalText = '<span>' + text + '' +
                //     (changeText ? `<span style="font-size: 80%; color:${properties.darkTheme ? "white" : "black"}">(` + changeText + ')</span>' : '') +
                //     '</span>'
                //   this.series.userOptions.tooltip[this.point.x] = finalText;
                //   return (
                //     finalText
                //   );
                // }

                // if (properties.datalabelStyle == "significance") {
                //   text = this.y + (this.series.userOptions.data1[this.point.x]["isPercentage"] && '%');
                //   // text = this.y != 0 ? this.y + ( ispercentage && '%' ) : 'NA';
                //   let sig = this.series.userOptions.data1[this.point.x]["Significance"];
                //   let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                //   let sigcolor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                //   let finalText = '<span >' + text + '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span></span>';
                //   this.series.userOptions.tooltip[this.point.x] = finalText;
                //   return (
                //     finalText
                //   );
                // }

                // if (properties.datalabelStyle == "significance2") {
                //   text = this.y + (this.series.userOptions.data1[this.point.x]["isPercentage"] && '%');
                //   changeText = this.series.userOptions.data1[this.point.x]["ChangeVs"];
                //   let sig = this.series.userOptions.data1[this.point.x]["Significance"];
                //   let sig1 = this.series.userOptions.data1[this.point.x]["Significance2"];
                //   let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                //   let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : properties.darkTheme ? "white" : "Black");
                //   let sigcolor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                //   let finalText = '<span>' + text +
                //     (changeText ? '&nbsp<span style="color:' + ';"> ' +
                //       '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                //       '<span style="color:' + sigcolor + ';">' + s + '</span>' : '') +
                //     '</span>';
                //   this.series.userOptions.tooltip[this.point.x] = finalText;
                //   return (
                //     finalText
                //   );
                // }

                // if (properties.datalabelStyle == "ls") {
                //   text = this.series.userOptions.data1[this.point.x]["Sample size"] >= samplesizeConstantValue ? this.y + (this.series.userOptions.data1[this.point.x]["isPercentage"] && '%') : 'LS';
                //   let finalText = '<b>' +
                //     text +
                //     '</b> ' +
                //     '<span style="opacity: 0.5"></span>';
                //   this.series.userOptions.tooltip[this.point.x] = finalText;
                //   return (
                //     finalText
                //   );
                // }
              },
            },
          },
        },
        series: this.seriesData,
      } as any);

      // Legend is always at bottom in output mode; no left/right margin adjustments needed
    } else {
      localStorage.setItem('properties', JSON.stringify(this.ChartProperties));
      this.prepareSeriesDataForChart();
      let properties = this.ChartProperties;
      let samplesizeConstantValue = this.samplesizeConstantValue;
      //const updatedCategoryNames = this.LineTrendService.updatedCategories.map(category => category.image);
      //let updatedCategories = this.LineTrendService.updatedCategories;
      let ispercentage = false;
      let that = this;
      let colors = this.colorCodeList;
      if (this.ChartProperties.datalabelFormat === 'percentage') {
        ispercentage = true;
      }

      if (
        this.ChartProperties.stacking == 1 ||
        this.ChartProperties.stacking == 2
      ) {
        this.seriesData.reverse();
      }
      const containerEl = document.getElementById(containerId);
      if (!containerEl) {
        return;
      }
      this.chart = new Highcharts.Chart(containerEl, {
        chart: {
          type: 'line',
          marginLeft: 50, // Increase left margin
          marginRight: 50,
          backgroundColor: this.ChartProperties.darkTheme ? 'Black' : 'white',
          zooming: {
            type: 'xy',
          },
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
        },
        title: {
          text: '',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
            fontFamily: 'KantarBrown-Regular',
          },
          align: this.ChartProperties.chartTitlePosition,
        },
        credits: {
          enabled: false,
        },
        yAxis: this.plotyaxis(),
        xAxis: {
          title: {
            text: '',
            style: {
              fontSize: '12px',
              color: '#E8E8E8',
            },
          },
          // min: 0,
          gridLineWidth: this.ChartProperties.gridlines,
          categories: properties.axisImage
            ? this.updateCategoryName
            : this.categoriesList,
          labels: {
            rotation: this.LineTrendService.axisLabelOrientation(
              this.ChartProperties.axisLabelOrientation,
            ),
            style: {
              color: this.ChartProperties.darkTheme ? 'white' : 'Black',
            },
            useHTML: true,
            formatter: function (
              this: Highcharts.AxisLabelsFormatterContextObject,
            ) {
              if (properties.axisImage) {
                var index = this.axis.categories.indexOf(String(this.value));
                var category = that.updateCategoryName[index];

                if (category) {
                  return (
                    '<span style="display: inline-block; width: 2em; height: 2em; background: url(../../../../../../assets/Images/LineOrTrendChart/' +
                    category +
                    '.png) no-repeat center center; background-size: cover;"></span>'
                  );
                } else {
                  return '<span>No Image</span>';
                }
              } else {
                return String(this.value);
              }
            },
          },
        },

        tooltip: {
          enabled: true,
          borderWidth: 0,
          useHTML: true,
          shape: properties.toolTipStyle == 'style1' ? 'square' : 'callout',
          shadow: false,
          backgroundColor: 'rgba(0,0,0,0)',

          formatter: function () {
            if (this.series.name === 'Marker1') return false;
            let isDefaultTooltip = properties.toolTipStyle;
            const text = properties.showDataLabel
              ? this.series.userOptions.tooltip[this.point.x]
              : this.y;
            const dotColor = this.series.color;
            const backgroundcolor = properties.darkTheme
              ? '#b3b3b3'
              : '#f5f5f5';
            const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';
            if (isDefaultTooltip == 'style1') {
              const commonContent =
                `<div style="width:120%;border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 3%; border-radius: 5px; margin: 0; background-color: ${backgroundcolor2};">` +
                `<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 1rem;">Tooltip Title</span>` +
                `<span><strong>Series Name:</strong></span> ${this.series.userOptions.name}<br>` +
                `<span><strong>Category Name:</strong></span> ${this.series.userOptions.data1[this.point.x]['Category Name']}<br>` +
                `<span><strong>Value:</strong></span> ${text}`;
              return commonContent + '</div>';
            } else {
              // Get the series color
              const content =
                `<div style="background-color: ${backgroundcolor}; padding: 10%; align-items: center; border: 1px solid ${dotColor}; width:120%">` +
                `<div style="width: 1em; height: 1em; background-color: ${dotColor}; border-radius: 50%; margin-right: 5%;"> </div>` +
                ` ${this.series.name}` +
                `<div style="display: block; margin-top: 1%;"><strong>Value:</strong> ${text}</div>`;
              return content + '</div>';
            }
          },
        } as any,
        legend: this.LineTrendService.customizeLegend(
          properties.showLegend,
          properties.legendPosition,
          this.ChartProperties.darkTheme,
          this.ChartProperties.stacking,
        ),
        plotOptions: {
          series: {
            animation: false,
          },
          line: {
            stacking:
              this.ChartProperties.stacking == 0
                ? ''
                : this.ChartProperties.stacking == 1
                  ? 'normal'
                  : 'percent',
            lineWidth: properties.lineWidth,
            dashStyle: properties.gridLineDashStyle,
            fillOpacity: 0.4,
            marker: {
              enabled: true,
              symbol: properties.markerStyle,
              radius: 4,
              lineWidth: properties.markerLineWidth,
            },
            dataLabels: {
              enabled: properties.showDataLabel,
              allowOverlap: true,
              align:
                properties.dataLabelPositionPPT == 'left'
                  ? 'right'
                  : properties.dataLabelPositionPPT == 'right'
                    ? 'left'
                    : 'center',
              rotation: properties.datalabelOrientation,
              backgroundColor: 'transparent',
              color: properties.darkTheme
                ? properties.dataLabelColor === 'default'
                  ? 'white'
                  : properties.dataLabelColor
                : properties.dataLabelColor === 'default'
                  ? 'black'
                  : properties.dataLabelColor,
              style: {
                fontSize: properties.dataLabelSize,
                textOutline: 'none',
                fontWeight: 'normal',
              },
              formatter: function (this: any) {
                const upwardTriangle = '&#9650';
                const downwardTriangle = '\u25BC';
                let text;
                let changeText;
                let roundedValue =
                  this.series.userOptions.data1[this.point.x]['Rounded Value'];
                if (roundedValue == null) {
                  this.series.userOptions.tooltip[this.point.x] = 'NA';
                  return 'NA';
                }

                if (properties.datalabelStyle == 'sigchan') {
                  text = this.y + (ispercentage && '%');
                  changeText =
                    this.series.userOptions.data1[this.point.x]['ChangeVs'];
                  let sig =
                    this.series.userOptions.data1[this.point.x]['Significance'];
                  let s =
                    sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                  let finalText =
                    '<span>' +
                    text +
                    (changeText
                      ? '&nbsp;<span>' +
                        '' +
                        `<span style="font-size: 80%; color:${properties.darkTheme ? 'white' : 'black'}">(` +
                        changeText +
                        ')</span>' +
                        '&nbsp;' +
                        '<span style="color:' +
                        sigcolor +
                        ';">' +
                        s +
                        '</span>'
                      : '') +
                    '</span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;

                  return finalText;
                }

                if (properties.datalabelStyle == 'change') {
                  text = this.y + (ispercentage && '%');
                  //text = this.y != 0 ? this.y + ( ispercentage && '%' ) : 'NA';
                  changeText =
                    this.series.userOptions.data1[this.point.x]['ChangeVs'];
                  let finalText =
                    '<span>' +
                    text +
                    '' +
                    (changeText
                      ? `<span style="font-size: 80%; color:${properties.darkTheme ? 'white' : 'black'}">(` +
                        changeText +
                        ')</span>'
                      : '') +
                    '</span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return finalText;
                }

                if (properties.datalabelStyle == 'significance') {
                  text = this.y + (ispercentage && '%');
                  // text = this.y != 0 ? this.y + ( ispercentage && '%' ) : 'NA';
                  let sig =
                    this.series.userOptions.data1[this.point.x]['Significance'];
                  let s =
                    sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                  let finalText =
                    '<span >' +
                    text +
                    '&nbsp<span style="color:' +
                    sigcolor +
                    ';">' +
                    s +
                    '</span></span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return finalText;
                }

                if (properties.datalabelStyle == 'significance2') {
                  text = this.y + (ispercentage && '%');
                  changeText =
                    this.series.userOptions.data1[this.point.x]['ChangeVs'];
                  let sig =
                    this.series.userOptions.data1[this.point.x]['Significance'];
                  let sig1 =
                    this.series.userOptions.data1[this.point.x][
                      'Significance2'
                    ];
                  let s =
                    sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                  let changeColor =
                    sig1 < 0
                      ? 'red'
                      : sig1 > 0
                        ? 'green'
                        : properties.darkTheme
                          ? 'white'
                          : 'Black';
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                  let finalText =
                    '<span>' +
                    text +
                    (changeText
                      ? '&nbsp<span style="color:' +
                        ';"> ' +
                        '<span style="font-size: 80%; color:' +
                        changeColor +
                        ';">(' +
                        changeText +
                        ')</span>&nbsp' +
                        '<span style="color:' +
                        sigcolor +
                        ';">' +
                        s +
                        '</span>'
                      : '') +
                    '</span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return finalText;
                }

                if (properties.datalabelStyle == 'lowSample') {
                  text =
                    this.series.userOptions.data1[this.point.x][
                      'Sample Size'
                    ] >= samplesizeConstantValue
                      ? this.y + (ispercentage && '%')
                      : 'LS';
                  let finalText =
                    '<b>' +
                    text +
                    '</b> ' +
                    '<span style="opacity: 0.5"></span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return finalText;
                }
                let finalText = this.y + (ispercentage && '%');
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              },
            },
          },
        },
        series: this.seriesData,
      } as any);

      //var chart = this.chart;
      // var legendWidth = chart.legend.legendWidth;
      // // Adjust margins based on the legend width

      // if (
      //   this.ChartProperties.legendPosition == 'left' &&
      //   this.ChartProperties.showLegend
      // ) {
      //   this.chart.update(
      //     {
      //       chart: {
      //         marginLeft: legendWidth + 50, // Add some extra space
      //         marginRight: 30,
      //       },
      //     },
      //     false,
      //   );
      // }

      // if (
      //   this.ChartProperties.legendPosition == 'right' &&
      //   this.ChartProperties.showLegend
      // ) {
      //   this.chart.update(
      //     {
      //       chart: {
      //         marginLeft: legendWidth + 5, // Add some extra space
      //         marginRight: legendWidth + 25,
      //       },
      //     },
      //     false,
      //   );
      // }
    }
  }

  // getTooltipValue(value:any,actualValue:any,sampleSize:any){
  //   if(sampleSize >= 1000){
  //     return actualValue == null ? 'NA' : value;
  //   }
  //   return actualValue == null ? 'NA' : "LS";
  // }
  // prepareSeriesDataForChart() {
  //   if (this.isOutput) {
  //     this.seriesData = [];

  //     this.LineChartData = this.chartMainData;

  //     let metrics = _.uniqBy(this.LineChartData, 'Series Name').map((item) => {
  //       return item['Series Name'];
  //     });

  //     this.categoriesList = _.uniqBy(this.LineChartData, 'Category Name').map(
  //       (item) => {
  //         return item['Category Name'];
  //       }
  //     );

  //     let uniqueDataValue = _.uniqBy(this.LineChartData, 'Rounded Value').map(
  //       (item) => {
  //         return item['Rounded Value'];
  //       }
  //     );

  //     if (this.ChartProperties.datalabelStyle === 'lowSample') {
  //       this.showLowSample = true;
  //     } else {
  //       this.showLowSample = false;
  //     }

  //     let minValue = Math.min(...uniqueDataValue);
  //     let maxValue = Math.max(...uniqueDataValue);
  //     this.chartMinAxis = minValue;
  //     this.chartMaxAxis = maxValue + maxValue * 0.05;

  //     let idx = 0;
  //     let dataObject: any = {};
  //     let consumableData: any = [];
  //     let consumableData1: any = [];

  //     metrics.forEach((metric) => {
  //       dataObject = {};
  //       consumableData = [];
  //       consumableData1 = [];

  //       //let metricData = this.LineChartData.filter( res => res["Series Name"] == metric);
  //       let i = 0;
  //       this.categoriesList.forEach((item: any) => {
  //         let metricData: any;
  //         metricData = this.LineChartData.filter(
  //           (res) => res['Series Name'] == metric && res['Category Name'] == item
  //         )[0];
  //         if (!this.updateCategoryName.includes(metricData['Category Image'])) {
  //           this.updateCategoryName.push(metricData['Category Image']);
  //         }

  //         if (this.showLowSample) {
  //           if (metricData['Sample size'] < this._configService.ISthreshold) {
  //             consumableData.push({
  //               y: 0,

  //             });
  //           } else {
  //             consumableData.push({
  //               y:
  //                 metricData['Value'] == null
  //                   ? null
  //                   : Number(
  //                     parseFloat(metricData['Value']).toFixed(
  //                       this.ChartProperties.decimalRoundOff
  //                     )
  //                   ),
  //               indexValue: metricData['ValueForIndex'] == null
  //                 ? null
  //                 : Number(
  //                   parseFloat(metricData['ValueForIndex']).toFixed(
  //                     this.ChartProperties.decimalRoundOff
  //                   )
  //                 )
  //             });
  //           }
  //         } else {
  //           if (
  //             this._configService.userRole != 'superadmin' &&
  //             metricData['Sample size'] < this._configService.ISthreshold
  //           ) {
  //             consumableData.push({
  //               y: 0,
  //               cov: "I/S",
  //             });
  //           } else {
  //             consumableData.push({
  //               name: metric,
  //               y:
  //                 metricData['Value'] == null
  //                   ? null
  //                   : Number(
  //                     parseFloat(metricData['Value']).toFixed(
  //                       this.ChartProperties.decimalRoundOff
  //                     )
  //                   ),
  //               y1:
  //                 metricData['Value'] == null
  //                   ? null
  //                   : Number(
  //                     parseFloat(metricData['Value']).toFixed(
  //                       this.ChartProperties.decimalRoundOff
  //                     )
  //                   ),
  //               indexValue: metricData['ValueForIndex'] == null
  //                 ? null
  //                 : Number(
  //                   parseFloat(metricData['ValueForIndex']).toFixed(
  //                     this.ChartProperties.decimalRoundOff
  //                   )
  //                 ),
  //               cov: metricData['ChangeVs'],
  //               significance: metricData['Significance'],
  //               samplesize: metricData['Sample size'],
  //               significance2: metricData['Significance2'],
  //               tooltip: '',
  //               isPercentage: metricData['isPercentage'],
  //               Sig_LowerLimt: metricData['Sig_LowerLimt'],
  //               Sig_UpperLimt: metricData['Sig_UpperLimt'],

  //               // "Series Name": lev2.metricName,
  //               // "Category Name": dataArr.lvl1Child,
  //               // "Rounded Value": dataArr.data == null ? null : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : dataArr.data,
  //               // "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : dataArr.data,
  //               // "Label": dataArr.data == null ? "NA" : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : dataArr.data,
  //               // "ChangeVs": dataArr.changeVsPY,
  //               // "Significance": "-1",
  //               // "Sample size": dataArr.baseValueforLSorIs,
  //               // "Significance2": "1",
  //               // "Category Image": "Category_Image_1",
  //               // "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
  //               // "Sig_LowerLimt": this.Sig_LowerLimt,
  //               // "Sig_UpperLimt": this.Sig_UpperLimt
  //             });
  //           }
  //         }
  //         consumableData1.push(metricData);
  //         i++;
  //       });

  //       dataObject.name = metric;
  //       dataObject.color = this.colorCodeList[idx++];
  //       dataObject.data = consumableData;
  //       dataObject.data1 = consumableData1;
  //       dataObject.connectNulls = false;
  //       dataObject.tooltip = [];
  //       //dataObject.pointPlacement = "on";
  //       this.seriesData.push(dataObject);
  //     });
  //   }
  //   else {
  //     this.seriesData = [];

  //     let metrics = _.uniqBy(this.LineChartData, "Series Name").map(item => {
  //       return item["Series Name"];
  //     });

  //     this.categoriesList = _.uniqBy(this.LineChartData, "Category Name").map(item => {
  //       return item["Category Name"];

  //     })

  //     let uniqueDataValue = _.uniqBy(this.LineChartData, "Value").map(item => {
  //       return item["Value"];
  //     });

  //     if (this.ChartProperties.datalabelStyle === "lowSample") {
  //       this.showLowSample = true;
  //     } else {
  //       this.showLowSample = false;
  //     }

  //     let minValue = Math.min(...uniqueDataValue);
  //     let maxValue = Math.max(...uniqueDataValue);
  //     this.chartMinAxis = Math.floor(minValue - (minValue * 0.10));
  //     this.chartMaxAxis = Math.ceil(maxValue + (maxValue * 0.10));

  //     let idx = 0;
  //     let dataObject: any = {};
  //     let consumableData: any = [];
  //     let consumableData1: any = [];

  //     metrics.forEach((metric) => {
  //       dataObject = {};
  //       consumableData = [];
  //       consumableData1 = [];

  //       //let metricData = this.LineChartData.filter( res => res["Series Name"] == metric);
  //       let i = 0;
  //       this.categoriesList.forEach((item: any) => {
  //         let metricData: any;
  //         metricData = _.cloneDeep(this.LineChartData.filter(res => res["Series Name"] == metric && res["Category Name"] == item)[0]);
  //         metricData["Value"] = metricData["Value"] == null ? 0 : parseFloat(Number(_.cloneDeep(metricData["Value"])).toFixed(this.ChartProperties.decimalRoundOff));
  //         if (!this.updateCategoryName.includes(metricData["Category Image"])) {
  //           this.updateCategoryName.push(metricData["Category Image"]);
  //         }

  //         if (this.showLowSample) {
  //           if (metricData["Sample Size"] < this.samplesizeConstantValue) {
  //             consumableData.push({
  //               y: 0
  //             })
  //           } else {
  //             consumableData.push({
  //               y: metricData["Value"] == null ? 0 : metricData["Value"]
  //             })
  //           }
  //         } else {
  //           consumableData.push({
  //             y: metricData["Value"] == null ? 0 : metricData["Value"]
  //           })
  //         }
  //         consumableData1.push(metricData);
  //         i++;
  //       })

  //       dataObject.name = metric;
  //       dataObject.color = this.colorCodeList[idx++];
  //       dataObject.data = consumableData;
  //       dataObject.data1 = consumableData1;
  //       dataObject.tooltip = [];
  //       //dataObject.pointPlacement = "on";
  //       this.seriesData.push(dataObject);
  //     })
  //   }
  // }

  extractDisplayName(metricName: string): string {
    if (!metricName) {
      return '';
    }

    const parts = metricName
      .split('|')
      .map((part) => part.trim())
      .filter(Boolean);

    if (parts.length <= 1) {
      return metricName.trim();
    }

    const lastPart = parts[parts.length - 1];
    if (lastPart.toLowerCase().includes('t2b') && parts.length >= 2) {
      return `${parts[parts.length - 2]}|${lastPart}`;
    }

    return lastPart;
  }

  prepareSeriesDataForChart() {
    this.seriesData = [];
    //For Trenlines making the round off value to 0 as per the requirement
    this.ChartProperties.decimalRoundOff = 0;
    this.LineChartData = this.chartMainData;
    console.log('this.LineChartData', this.LineChartData);
    let metrics = _.uniqBy(this.LineChartData, 'Series Name').map((item) => {
      return item['Series Name'];
    });

    this.categoriesList = _.uniqBy(this.LineChartData, 'Category Name').map(
      (item) => {
        return item['Category Name'];
      },
    );

    if (this.shouldUseMetricTrendSeries()) {
      this.categoriesList.sort((a: string, b: string) =>
        this.compareTrendPeriodLabels(a, b),
      );
    }

    const numericDataValues = this.LineChartData
      .map((item) => Number(item['Rounded Value']))
      .filter((value) => Number.isFinite(value));
    this.hasNumericTrendData = numericDataValues.length > 0;

    if (this.ChartProperties.datalabelStyle === 'lowSample') {
      this.showLowSample = true;
    } else {
      this.showLowSample = false;
    }

    let minValue = this.hasNumericTrendData
      ? Math.min(...numericDataValues)
      : 0;
    let maxValue = this.hasNumericTrendData
      ? Math.max(...numericDataValues)
      : 0;
    this.chartMinAxis = minValue;
    this.chartMaxAxis =
      maxValue === 0 ? 10 : maxValue + Math.abs(maxValue) * 0.05;

    let idx = 0;
    let dataObject: any = {};
    let consumableData: any = [];
    let consumableData1: any = [];

    metrics.forEach((metric) => {
      dataObject = {};
      consumableData = [];
      consumableData1 = [];

      //let metricData = this.LineChartData.filter( res => res["Series Name"] == metric);
      let i = 0;
      this.categoriesList.forEach((item: any) => {
        let metricData: any;
        const matchingPoints = this.LineChartData.filter(
          (res) => res['Series Name'] == metric && res['Category Name'] == item,
        );
        metricData =
          matchingPoints.find((point: any) => point['Value'] != null) ??
          matchingPoints[0];
        if (!metricData) {
          consumableData.push({ y: 0 });
          consumableData1.push({});
          i++;
          return;
        }
        if (!this.updateCategoryName.includes(metricData?.['Category Image'])) {
          this.updateCategoryName.push(metricData['Category Image']);
        }

        if (this.showLowSample) {
          if (metricData['Sample size'] < this._configService.ISthreshold) {
            consumableData.push({
              y: 0,
            });
          } else {
            consumableData.push({
              y:
                this._configService.userRole != 'superadmin' &&
                Number(metricData['Sample size']) <=
                  this._configService.ISthreshold
                  ? 0
                  : !this.showLowSample
                    ? metricData['Value'] == null
                      ? 0
                      : Number(
                          parseFloat(metricData['Value']).toFixed(
                            this.ChartProperties.decimalRoundOff,
                          ),
                        )
                    : parseFloat(metricData['Sample size']) >
                        this.samplesizeConstantValue
                      ? metricData['Value'] == null
                        ? 0
                        : Number(
                            parseFloat(metricData['Value']).toFixed(
                              this.ChartProperties.decimalRoundOff,
                            ),
                          )
                      : 0,
              indexValue:
                metricData['ValueForIndex'] == null
                  ? 'NA'
                  : Number(
                      parseFloat(metricData['ValueForIndex']).toFixed(
                        this.ChartProperties.decimalRoundOff,
                      ),
                    ),
            });
          }
        } else {
          if (
            this._configService.userRole != 'superadmin' &&
            metricData['Sample size'] < this._configService.ISthreshold
          ) {
            consumableData.push({
              y: 0,
              cov: 'I/S',
              Significance_Value: metricData['Significance_Value'],
            });
          } else {
            consumableData.push({
              name: metric,
              y:
                this._configService.userRole != 'superadmin' &&
                Number(metricData['Sample size']) <=
                  this._configService.ISthreshold
                  ? 0
                  : !this.showLowSample
                    ? metricData['Value'] == null
                      ? 0
                      : Number(
                          parseFloat(metricData['Value']).toFixed(
                            this.ChartProperties.decimalRoundOff,
                          ),
                        )
                    : parseFloat(metricData['Sample size']) >
                        this.samplesizeConstantValue
                      ? metricData['Value'] == null
                        ? 0
                        : Number(
                            parseFloat(metricData['Value']).toFixed(
                              this.ChartProperties.decimalRoundOff,
                            ),
                          )
                      : 0,
              y1:
                metricData['Value'] == null
                  ? null
                  : Number(
                      parseFloat(metricData['Value']).toFixed(
                        this.ChartProperties.decimalRoundOff,
                      ),
                    ),
              indexValue:
                metricData['ValueForIndex'] == null
                  ? 'NA'
                  : Number(
                      parseFloat(metricData['ValueForIndex']).toFixed(
                        this.ChartProperties.decimalRoundOff,
                      ),
                    ),
              cov: metricData['ChangeVs'],
              significance: metricData['Significance'],
              samplesize: metricData['Sample size'],
              significance2: metricData['Significance2'],
              tooltip: '',
              color: metricData['color'],
              isPercentage: metricData['isPercentage'],
              Sig_LowerLimt: metricData['Sig_LowerLimt'],
              Sig_UpperLimt: metricData['Sig_UpperLimt'],
              Significance_Value: metricData['Significance_Value'],

              // "Series Name": lev2.metricName,
              // "Category Name": dataArr.lvl1Child,
              // "Rounded Value": dataArr.data == null ? null : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : dataArr.data,
              // "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : dataArr.data,
              // "Label": dataArr.data == null ? "NA" : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : dataArr.data,
              // "ChangeVs": dataArr.changeVsPY,
              // "Significance": "-1",
              // "Sample size": dataArr.baseValueforLSorIs,
              // "Significance2": "1",
              // "Category Image": "Category_Image_1",
              // "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
              // "Sig_LowerLimt": this.Sig_LowerLimt,
              // "Sig_UpperLimt": this.Sig_UpperLimt
            });
          }
        }
        consumableData1.push(metricData);
        i++;
      });

      // Use the helper function to extract the display name without metric group prefix
      dataObject.name = this.extractDisplayName(metric);
      // Extract brand name from metric (after pipe if present)
      // const brandName = metric.includes('|') ? metric.substring(metric.indexOf('|') + 1).trim() : metric.trim();
      if(!metric) {  
        metric="" ;
      }
      let brandName = metric ? metric.trim() : '';
      if (metric) {
        const parts = metric.split('|').map((p: string) => p.trim()).filter(Boolean);
        if (parts.length > 1) {
          // "Brands|Vanguard" / "brand|Vanguard" → Vanguard
          brandName = parts[parts.length - 1];
        }
      }

      // Use global color map if available for this brand, otherwise use default palette
      const isKPI = consumableData1[0]?.isAdditionalKPI ?? false;
      const globalColor = this.getColorFromGlobalMap(brandName);
      const hasMappedColor =
        typeof globalColor === 'string' && globalColor.trim().length > 0;
      const paletteColor =
        this.colorCodeList?.length > 0
          ? this.colorCodeList[idx++ % this.colorCodeList.length]
          : undefined;
      const seriesColor = isKPI
        ? '#9e9e9e'
        : hasMappedColor
          ? globalColor
          : paletteColor;
      dataObject.color = seriesColor;
      dataObject.isAdditionalKPI = isKPI;
      if (isKPI) {
        dataObject.marker = {
          lineColor: '#333333',
          lineWidth: 1,
          fillColor: '#9e9e9e',
        };
      }
      dataObject.data = consumableData;
      dataObject.data1 = consumableData1;
      dataObject.connectNulls = false;
      dataObject.tooltip = [];
      //dataObject.pointPlacement = "on";
      this.seriesData.push(dataObject);
    });
  }

  getDataValue(sampleSize: any, value: any) {
    if (sampleSize >= this.samplesizeConstantValue) return value;
    return 0;
  }

  private getMonthNumber(monthAbbr: any): number {
    const months = [
      ['jan', 'january'],
      ['feb', 'february'],
      ['mar', 'march'],
      ['apr', 'april'],
      ['may', 'may'],
      ['jun', 'june'],
      ['jul', 'july'],
      ['aug', 'august'],
      ['sep', 'september'],
      ['oct', 'october'],
      ['nov', 'november'],
      ['dec', 'december'],
    ];

    const normalized = monthAbbr?.toLowerCase().trim();
    const index = months.findIndex((aliases) => aliases.includes(normalized));
    return index + 1;
  }

  userselectedproperties() {
    let linechartData = {
      data: this.LineChartData,
      Properties: [this.ChartProperties],
      title: this.data.title,
    };
    return JSON.stringify(linechartData).toString();
  }
  customization(): Observable<any> {
    // return this.LineTrendService.Line1CustomizationList();
    const snapshotTypeSelectedName =
      this._customSnapshotService.selectedSnapshotType?.name;
    const cohortType =
      snapshotTypeSelectedName &&
      snapshotTypeSelectedName.toLowerCase().includes('audience')
        ? this._configService.audienceCohortType
        : 'NA';
    return this._customSnapshotService.getChartCustomization(
      'Trend Line',
      snapshotTypeSelectedName,
      cohortType,
    );
  }

  private isBrandDependentMode(properties: any): boolean {
    const raw =
      properties?.branddependent ??
      properties?.BrandDependent ??
      properties?.bdBiToggle;

    if (raw === undefined || raw === null || raw === '') {
      return true;
    }

    if (typeof raw === 'string') {
      const normalized = raw.trim().toLowerCase();
      return normalized === 'true' || normalized === 'enable';
    }

    return !!raw;
  }

  private getColorFromGlobalMap(brandName: string): string | null {
    if (!this.isBrandDependentMode(this.ChartProperties)) {
      return null;
    }
    // Series are metrics when a brand is selected — skip brand palette
    if (this.brandSelected && !this.metricSelected) {
      return null;
    }
    if (!brandName || !this.globalColorMap) {
      return null;
    }

    const normalized = brandName.trim().toLowerCase();
    const matchedKey = Object.keys(this.globalColorMap).find((key) => {
      const keyNorm = key.toLowerCase().trim();
      const keyTail = keyNorm.includes('|')
        ? (keyNorm.split('|').pop() || keyNorm)
        : keyNorm;
      return keyNorm === normalized || keyTail === normalized;
    });

    return matchedKey ? this.globalColorMap[matchedKey] : null;
  }
  applycustomization(event: any, item: string) {
    this.event = event;
    //choose the appropriate customization
    this.LineTrendService.applycustomization(event, item, this.ChartProperties);
    this.plotLineChart(this.chartContainerId);
  }
}
